import { toast as e } from "../components/toast/index.mjs";
import { createHttpClient as t, getErrorMapper as n, getUseBaseFetch as r } from "@systemeio/util";
//#region src/utils/http-client.ts
var i = t();
i.interceptors.response.use((e) => e, n(i));
var a = r({
	httpClient: i,
	useRouter: () => ({
		push: async (e) => (window.location.assign(e), !0),
		replace: async (e) => (window.location.replace(e), !0)
	}),
	toast: e
});
//#endregion
export { i as httpClient, a as useFetch };
